var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shadow-sm border border-teal-500 rounded p-4 bg-white"},[_c('p',[_vm._v(" "+_vm._s(_vm.fullName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }